import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HostListener } from "@angular/core";

@Component({
    selector: 'app-request-clinic',
    templateUrl: './request-clinic.component.html',
    styleUrls: ['./request-clinic.component.scss'],
    standalone: false
})
export class RequestClinicComponent implements OnInit {
  visible:boolean = true;
  screenWidth: number = 0;
  hideMob: boolean = false;
  @Input() public currentRoute:string;
  constructor(private router: Router) { 
    console.log("this.router44= "+router);
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.hideMob = this.screenWidth <=  767;
  }

  hasRoute(route: string) {
    return this.router.url.includes(route);
  }

  @HostListener('window:resize', ['$event'])
    onResize(event?: any) {
      this.screenWidth = window.innerWidth;
      this.hideMob = this.screenWidth <=  767;
    }
}
